
  <div class="navbar-fixed">
    <nav class="indigo">
      <div class="nav-wrapper">
        <a href="#!" class="mylogo" style="margin-left: 10px;">{{title}}</a>
        <a href="#!" data-target="slide-out" class="sidenav-trigger"><i class="material-icons">menu</i></a>

        <ul id="nav-mobile" class="right hide-on-med-and-down">
          <li><a routerLink=""><i class="material-icons left">home</i>Home</a></li>
          <li><a href="https://scl.samsaadhanii.in/scl/" target="_blank"><i class="material-icons left">settings_applications </i>संसाधनी</a></li>
          <li><a [routerLink]="['/about']" routerLinkActive="router-link-active"><i class="material-icons left">people</i>About</a></li>
          <li><a [routerLink]="['/ereader']" routerLinkActive="router-link-active"><i class="material-icons left">speaker_notes</i>e-Reader</a></li>
          <li><a href="https://scl.samsaadhanii.in/scl/" target="_blank"><i class="material-icons left">email</i>Contact Us</a></li>
        </ul>
      </div>
    </nav>
  </div>

  <ul id="slide-out" class="sidenav">
    <li class="indigo"><div class="user-view">
      <!-- <div class="background"> -->
        <h4 href="#!" class="center white-text">भगवद्गीता</h4>
        <img src="assets/images/banner.png" class="responsive-img">
      <!-- </div> -->
      <!-- <a href="#user"><img class="circle" src="images/yuna.jpg"></a>
      <a href="#name"><span class="white-text name">John Doe</span></a>
      <a href="#email"><span class="white-text email">jdandturk@gmail.com</span></a> -->
    </div></li>
          <li class="sidenav-close"><a routerLink=""><i class="material-icons left">home</i>Home</a></li>
          <li class="sidenav-close"><a href="https://scl.samsaadhanii.in/scl/" target="_blank"><i class="material-icons left">settings_applications </i>संसाधनी</a></li>
          <li class="sidenav-close"><a [routerLink]="['/about']" routerLinkActive="router-link-active"><i class="material-icons left">people</i>About</a></li>
          <li class="sidenav-close"><a [routerLink]="['/ereader']" routerLinkActive="router-link-active"><i class="material-icons left">speaker_notes</i>e-Reader</a></li>
          <li class="sidenav-close"><a href="https://scl.samsaadhanii.in/scl/" target="_blank"><i class="material-icons left">email</i>Contact Us</a></li>
  </ul>
        